import { createEvent } from "@cobuildlab/react-simple-state";
/* @ts-ignore */
import { Contact } from "@devsplan/wealthclub-shared";

export const OnFetchContacts = createEvent<Contact[]>();
export const OnFetchContactsError = createEvent();
